class SignInPresenter {
  constructor(view, signInUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    try {
      // const masterKey = "77e27f20-2a6c-4b7b-b44e-1356c6d69768";
      const user = {
        ...this.change,
        // masterKey,
      };

      this.view.showProgress();

      const signedInUser = await this.signInUseCase.execute(user);

      switch (signedInUser.roles[0]?.name) {
        case "Staff":
          this.view.navigateTo("/collections/inventory/list");
          break;
        default:
          this.view.navigateTo("/sales&transactions");
          break;
      }

      // this.view.navigateTo("/sales&transactions");
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default SignInPresenter;
